import React,{useState} from 'react';
import {TableDatePicker,btnSetColor_CBack,btnSetColorDirect_CBack} from '../function_lib/common_lib';

export const Comp_Purchase_Balance=(props)=>{
    const [file, setFile] = useState(null);
    const handleFileChange = (e) => {
        setFile(e.target.files[0]); // get selected file
      };

    const handleUpload = () => {
        if (!file) {
          alert("Please select a file first");
          return;
        }
    
       
      };

      const addPurchaseRequest=()=>{
        //alert("i min click");
        btnSetColorDirect_CBack(this,"frmPurchaseBalance","addDeductBalanceClient",function(data,msg){
            if(data==="001"){
              alert(msg);
              window.location.reload();
            }else{
              alert(msg);
            }
          })
      }

    return(<div className="modal fade" id="divPurchaseBalance" tabindex="-1" role="dialog">
    
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    
                    <button type="button" className="close" data-bs-dismiss="modal" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">x</span></button>
                </div>
                <div className="modal-body" style={{"justify-content":"center",
    "align-items": "center"}}>
        
        <div class="d-flex flex-column flex-md-row">
        <div class="box">
            <p>Payable to:Legal Owner of Digital Seva Point (*) we allowing to pay to account</p>
            <p>
                Bank Name: <strong>ICICI Bank</strong><br></br>
                Account No: <strong>418501500981</strong> , IFSC: <strong>ICIC0004185</strong>
            </p>
           
           
            <p>A/c Holder: <strong>Jaypal Meena</strong></p>
            
            <p>Contact No: <strong>7999612682</strong></p>
            <p>
                <img src={"./payment_qr.jpeg"} style={{"maxWidth":"100%"}}/>
            </p>
            </div>    
            <div class="box">
                <div id="shiiping_add" style={{"width":"70%","margin":"auto"}}>
                               (* after payment send approval request to  admin)
                               <h3>Purchase Balance</h3>
                               <form id="frmPurchaseBalance" name="frmPurchaseBalance" method="POST" enctype="multipart/form-data">
                               <input type="hidden" name="curl_type" id="curl_type" value="addDeductBalanceClient" />  
                <input type="hidden" name="m_type" id="m_type" value="addDeductBalanceClient" />
                <input type="hidden" name="loc_token" id="loc_token" value={props.compUser[0]["id"]} />
                <input type="hidden" name="res_func" id="res_func" value={btoa("no callbakc")}/>
                <input type="hidden" name="gb_token" id="gb_token" value="5e7hmtL7R0GU7zEBVhJZmrKx8Qb4xy-G_ihGPxqUtrGt5qMHlOaQK8ba1r-o7qKuAChRCIL0_Pilz1gStWW2Mg" />
                               <div className="row">
                               <div className="col-lg-12">
                                       <div className="billing-select mb-4">
                                           <label>Purchase Balance</label>
                                           <select className="form-control required" id="balance" name="balance">
                                              <option value={"0"}>-Transaction-</option>
                                              <option value={"499"}>499 /-</option>
                                              <option value={"999"}>999 /-</option>
                                              <option value={"1499"}>1499 /-</option>
                                              <option value={"1999"}>1999 /-</option>
                                              <option value={"2499"}>2499 /-</option>
                                              <option value={"3499"}>3499 /-</option>
                                           </select>
                                       </div>
                                   </div>
                                   <div className="col-lg-12 col-md-12">
                                       <div className="billing-info mb-4">
                                           <label>Payment Mode</label>
                                        <select className="form-control required" id="payment_mode" name="payment_mode">
                                              <option value={"0"}>-Transaction-</option>
                                              <option value={"Net Banking"}>-Net Banking-</option>
                                              <option value={"UPI"}>-UPI-</option>
                                        </select>
                                       </div>
                                   </div>
                                 
                                   <div className="col-lg-12">
                                       <div className="billing-info mb-4">
                                           <label>Narration</label>
                                           <input className="billing-address form-control required11" id="narration" name="narration" placeholder="House number and street name" type="text" />
                                           
                                       </div>
                                   </div>
                                  

                                  
                                 
                                   <div className="col-lg-g col-md-12">
                                       <div className="billing-info mb-4">
                                           <label>UTR/Transaction-ID</label>
                                           <input className="form-control required" id="utr_trans_id" name="utr_trans_id" type="text" />
                                       </div>
                                   </div>

                                   <div className="col-lg-g col-md-12">
                                       <div className="billing-info mb-4">
                                           <label>Upload Transaction Attachment</label>
                                           <input class="form-control" type="file" id="upd_attach" name="upd_attach" onChange={handleFileChange} />
      

                                           {/* <input className="form-control required" id="utr_trans_id" name="utr_trans_id" type="text" /> */}
                                       </div>
                                   </div>
                                  
                                 
                                   
                                   
                               </div>
                               <div id="getRegLognNewAdd" style={{color:"red"}}></div>
                            <div className="Place-order mt-25">
                                        <button  className="btn btn-primary btn-outline-dark current-btn float-right _btnSetColor111" onClick={()=>addPurchaseRequest()} type="button"><span>Submit for Approval</span></button>
                            </div>
                               </form>
                               
                               </div>
                               {/* col div */}

                               </div>
                               </div>         
                </div>
            </div>
        </div>
        </div>)

}
export default Comp_Purchase_Balance;